import React from "react";

import { Gender } from "../../../../common/interfaces/enums/Gender";
import { useFormikContext } from "formik";

//interfaces
import { IClient } from "../../../../common/interfaces/IClient";
import { IFamilySettingsForm } from "../ClientDetailsSection/ClientDetailsSection";

//components
import Button from "../../../../common/components/Forms/Button/Button";
import Toggle from "../../../../common/components/Forms/Toggle/Toggle";
import Icon from "../../../../common/components/Icon/Icon";
import useSettingsValidation from "../../../hooks/useSettingsValidation";

interface IClientChildrenBox {
    client: IClient;
    index: number;
    onDelete: (index: number) => void;
    clients: IClient[];
}

const ClientChildrenBox: React.FC<IClientChildrenBox> = (props) => {
    const { client, index, onDelete } = props;

    const { setFieldValue } = useFormikContext<IFamilySettingsForm>();

    const { getFormikError } = useSettingsValidation();

    function setProperty<K extends keyof IClient>(key: K, value: IClient[K]): void {
        setFieldValue(`clients.[${index}].${key}`, value);
    }

    const getError = (param: keyof IClient): string | boolean => {
        return getFormikError(`clients.[${index}].${param}`);
    };

    const genderOptions = Object.keys(Gender)
        .filter((k) => k != Gender.Unknown)
        .map((k) => {
            return {
                selected: client.gender === Gender[k],
                id: Gender[k],
                label: Gender[k]
            };
        });

    return (
        <div className="layout-flex-row">
            <Toggle
                label={`Gender`}
                name={`clients.[${index}].gender`}
                options={genderOptions}
                onChange={(value) => {
                    setProperty("gender", value as Gender);
                }}
                hasError={getError("gender")}
                className="gap-ml"
            />
            {onDelete && (
                <Button
                    className="gap-pre-2xl space-pre-ml"
                    component="button"
                    variant="box"
                    onClick={() => onDelete(index)}>
                    <Icon id="TrashCan" size="2xl"/>
                </Button>
            )}
        </div>
    );
};

export default ClientChildrenBox;
